import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import parse from "html-react-parser";
import Aux from "../../hoc/Auxiliare";
import GLOBAL_CONFIG from "../../config/config";
import appGoogleTracking from "../../modules/googletracking";
import { mainLoaderToggle } from "../../modules/helpers";
import TitleContent from "../../components/Content/TitleContent/TitleContent";
import StepContent from "../../components/Content/StepContent/StepContent";
import GiftContentFooter from "../../components/Content/GiftContent/GiftContentFooter";
import { NavLink } from "react-router-dom";

class Faq extends Component {
  constructor() {
    super();
    this.Mapping = ["one", "two", "three", "four", "five"];
    this.state = {
      isMobile: false,
    };
    this.resize = this.resize.bind(this);
  }

  resize() {
    // set isMobile to true if the device is a mobile and false otherwise
    this.setState({ isMobile: window.innerWidth <= 768 });
  }

  componentDidMount() {
    const { t } = this.props;
    //Remove main loader
    mainLoaderToggle("hide");

    const link1 = document.getElementById("link1");
    const link2 = document.getElementById("link2");
    const link3 = document.getElementById("link3");
    const link4 = document.getElementById("link4");

    if (link1 || link2 || link3) {
      link1.addEventListener("click", function (event) {
        appGoogleTracking.dataLayerPush({
          dataEvent: "upload_receipt_link",
          dataCategory: "FAQ Page",
          dataAction: "Click on Link",
          dataLabel: "GAME_FAQ_PART",
        });
      });
      link2.addEventListener("click", function (event) {
        appGoogleTracking.dataLayerPush({
          dataEvent: "upload_receipt_link",
          dataCategory: "FAQ Page",
          dataAction: "Click on Link",
          dataLabel: "GAME_FAQ_PART",
        });
      });
      link3.addEventListener("click", function (event) {
        appGoogleTracking.dataLayerPush({
          dataEvent: "go_to_contact_us",
          dataCategory: "FAQ Page",
          dataAction: "Go to Page",
          dataLabel: "ENG_FAQ_PART",
        });
      });
      link4.addEventListener("click", function (event) {
        appGoogleTracking.dataLayerPush({
          dataEvent: "go_to_contact_us",
          dataCategory: "FAQ Page",
          dataAction: "Go to Page",
          dataLabel: "ENG_FAQ_PART",
        });
      });
    } else {
      console.log("error");
      console.error("Element with the specified ID not found.");
    }

    //Virtual page
    appGoogleTracking.dataLayerPush({
      customEvent: {
        event: "virtual-page",
        virtualUri: GLOBAL_CONFIG.Route.faq,
        pageTitle: t("Meta.title"),
      },
    });

    window.addEventListener("resize", this.resize);
    this.resize();

    /* const elementSelector = document.querySelectorAll('.link a'),
            elementSelectorLength = elementSelector.length;

        for (let i = 0; i < elementSelectorLength; i++) {
            elementSelector[i].addEventListener('click', function (event) {
                appGoogleTracking.dataLayerPush({
                    'dataEvent': 'data_protection_info',
                    'dataEvent': 'data_protection',
                    'dataCategory': 'Start Page',
                    'dataAction': 'Click on Data Protection',
                    'dataLabel': 'ENG_SP_PART'
                });
            });
        } */
  }

  componentWillUnmount() {
    //Show mainloader
    mainLoaderToggle("show");
  }

  displayTitle(t) {
    if (window.PROMOTION_CAMPAIGN == "rewe") {
      return (
        <div className="s-content-title">
          <h1>
            FAQ´ s - Die vollständigen TNB´ s findest du{" "}
            <NavLink
              to={GLOBAL_CONFIG.Route.terms}
              exact
              data-event="button-click"
              data-category="Click Action"
              data-action="Terms"
              data-label = ""
              onClick={appGoogleTracking.processEventCTANavLink}
            >
              <>hier.</>
            </NavLink>
          </h1>
        </div>
      );
    } else if (window.PROMOTION_CAMPAIGN == "muller") {
      return (
        <div className="s-content-title">
          <h1>So einfach geht’s</h1>
        </div>
      );
    } else {
      return "So einfach geht’s";
    }
  }

  render() {
    const { t } = this.props;
    let classNameDeco = "content-faq-deco ";
    if (window.PROMOTION_CAMPAIGN === "rewe") {
      classNameDeco += "rewe";
    }

    return (
      <Aux>
        <div className="content-faq__kaufland">
          <div className="content-faq s-content-copy">
            {this.props.promotionCampaign === "kaufland" ? (
              // console.log('test', item)
              <div className={classNameDeco}>
                {t("Page.Faq.decoration", { returnObjects: true }).map(
                  (item, index) => {
                    console.log("test", item);
                    return (
                      <img
                        key={index}
                        src={item}
                        alt={`Decoration ${index}`}
                        className={this.Mapping[index]}
                      />
                    );
                  }
                )}
              </div>
            ) : null}
            {/* <img srcSet='/resources/images/kaufland/deco-1.png' width={100}  style={{position: 'absolute',top: '875px'}} />
                    <img srcSet='/resources/images/kaufland/deco-1.png' width={100}  style={{position: 'absolute',bottom: '162px'}}  />
                    <img srcSet='/resources/images/kaufland/deco-1.png' width={130}  style={{position: 'absolute',top: '120px',right:'80px'}} />
                    <img srcSet='/resources/images/kaufland/deco-1.png' width={130}  style={{position: 'absolute',bottom: '745px',right:'80px'}}  /> */}
            <div className="s-content-copy__item">
              <p className="headings">
                <strong>
                    Wie kann ich teilnehmen und die Rechnung hochladen?
                </strong>
              </p>
              <p>Die Teilnahme ist ganz einfach:</p>
              <ol>
                <li>
                    Kaufe 2 Milka Produkte
                </li>
                <li>
                    Lade die Rechnung{" "}
                  <a
                    id="link1"
                    href="/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    hier
                  </a>{" "}
                  hoch
                </li>
                <li>
                    Dreh das virtuelle Glücksrad und gewinne mit etwas Glück attraktive Preise
                </li>{" "}
              </ol>
              <br />
            </div>
            <div className="s-content-copy__item">
              {" "}
              <p className="headings">
                <strong>Mit welchen Produkten kann ich teilnehmen?</strong>
              </p>{" "}
              <p>
              Du kannst mit allen Milka Produkten teilnehmen, die du zwischen dem 01.04. und 30.09.2025 kaufst. Vielleicht entdeckst du auch ein paar schokoladige Überraschungen für deine Lieben.
              </p>
            </div>
            <div className="s-content-copy__item">
              {" "}
              <p className="headings">
                <strong>Wie lange kann ich an der Aktion teilnehmen?</strong>
              </p>{" "}
              <p>
                Du kannst bis einschließlich 30.09.2025 deine Rechnung hochladen und teilnehmen.
              </p>
            </div>
            <div className="s-content-copy__item">
              {" "}
              <p className="headings">
                <strong>Wie oft kann ich teilnehmen?</strong>
              </p>{" "}
              <p>Du kannst beliebig oft teilnehmen, allerdings ist jeder Kaufbeleg nur einmal gültig.</p>
            </div>
            <div className="s-content-copy__item">
              {" "}
              <p className="headings">
                <strong>Kann ich einen Kaufbeleg mehrmals nutzen?</strong>
              </p>{" "}
              <p>Nein, jede Rechnung ist nur einmal gültig.</p>
            </div>
            <div className="s-content-copy__item">
              {" "}
              <p className="headings">
                <strong>Kann jeder an der Aktion teilnehmen?</strong>
              </p>{" "}
              <p>
                Teilnehmen kann jede natürliche Person ab 18 Jahren mit Wohnsitz in Österreich.
              </p>
            </div>
            <div className="s-content-copy__item">
              {" "}
              <p className="headings">
                <strong>Wie erhalte ich meinen Preis?</strong>
              </p>{" "}
              <p>
              Verteilung / Versand der Gewinne / Rücküberweisungen erfolgen durch unsere Partneragenturen Baudek & Schierhorn und D&K Brand Activation.{" "}
              </p>
            </div>
            <div className="s-content-copy__item">
              {" "}
              <p className="headings">
                <strong>Endet die Aktion am 30.09.2025?</strong>
              </p>{" "}
              <p>
              Ja, bis einschließlich 30.09.2025 kannst du das Glücksrad drehen. Die Rechnung deiner Einkäufe{"  "}
              <a
                    id="link2"
                    href="/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    hier
                  </a>{" "} hochladen und mit etwas Glück gewinnst du einen der über 10.000 Preise. Danach ist das Gewinnspiel beendet.

              </p>
            </div>
            <div className="s-content-copy__item">
              {" "}
              <p className="headings">
                <strong>Kann ich meine Daten löschen?</strong>
              </p>{" "}
              <p>
                Nach Ende der Aktion werden die Teilnehmerdaten gelöscht. Soweit 
                keine gesetzlichen Aufbewahrungspflichten bestehen, erfolgt eine 
                umgehende Löschung der Daten, nachdem das Gewinnspiel abgewickelt 
                ist. Eine umgehende Löschung erfolgt bezüglich der Daten der 
                Nichtgewinner. Teilnahmedaten sind aus gesetzlichen und buchhalterischen Gründen 
                nach Maßgabe der §§ 257 HGB, 147 AO, 14b UStG aufzubewahren. Für diese 
                Speicherung der Teilnehmerdaten ist die Rechtsgrundlage Art. 6 Abs. 1 S. 
                1 lit. c) DS-GVO, da die Verarbeitung zur Erfüllung einer rechtlichen 
                Verpflichtung erforderlich ist, der Mondelez Österreich unterliegt. Aber 
                falls du deine Daten bereits während des Aktionszeitraums löschen möchtest, 
                ist das natürlich möglich. Dazu wendest du dich bitte direkt an unseren{" "}
                <a
                  id="link3"
                  href="https://contactus.mdlzapps.com/form?siteId=7GTws0jSEtgtqGQHH57lZw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Verbraucherservice*
                </a>
                . Eine Teilnahme an der Aktion ist dann leider nicht mehr möglich. Weitere 
                Informationen zum Umgang mit deinen Daten im Rahmen dieser Aktion findest 
                du in den Teilnahmebedingungen.
              </p>
            </div>
            <div className="s-content-copy__item">
              {" "}
              <p className="headings">
                <strong>
                  An wen kann ich mich wenden, wenn ich weitere Fragen habe?
                </strong>
              </p>{" "}
              <p className="last">
                {" "}
                Vielleicht hast du noch weitere Fragen, die hier nicht
                beantwortet worden sind. Dann wende dich am besten direkt an
                unseren{" "}
                <a
                  id="link4"
                  href="https://contactus.mdlzapps.com/form?siteId=7GTws0jSEtgtqGQHH57lZw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Verbraucherservice*
                </a>
                .<br />
                <br />
              </p>{" "}
              <p className="edeka">
                *Falls der hier hinterlegte Link zum Verbraucherservice nicht
                funktioniert, kannst du über den Kontaktlink im Bereich
                „Service“ den Verbraucherservice erreichen.{" "}
              </p>
            </div>
          </div>
        </div>
      </Aux>
    );
  }
}

export default withTranslation()(Faq);
